module.exports = __webpack_public_path__ + "static/media/HoneyN'Oatmeal Cookies 200g.db4ddf78.jpg";